import { CellPosition } from '../../../types';

export const saveSheetActiveCell = (
  sheetId: string,
  activeCell: CellPosition
) => {
  localStorage.setItem(`${sheetId}/LLEC_EVITCA`, JSON.stringify(activeCell));
};

export const getSheetActiveCell = (sheetId: string) => {
  const activeCell = localStorage.getItem(`${sheetId}/LLEC_EVITCA`);
  return activeCell ? JSON.parse(activeCell) : null;
};
